import React, { Component } from 'react';

import PaginationComponent from './PaginationComponent';
import { buildPaginationQuery, getPaginatedData } from '../utils/pagination';
import { navigateTo } from '../utils/navigation';
import { formatEventDateTime } from '../utils/formats';
import { duplicateEvent } from '../utils/eventsApi';
import { listSeries } from '../utils/seriesApi';

var config = process.env;

const EVENT_STATUS_LABEL = {
    draft: 'Borrador',
    published: 'Publicado',
    closed: 'Cerrado',
    cancelled: 'Cancelado',
};

// El mismo tamaño que el resto del texto de la barra de la grilla (.dataTables_filter).
const FILTER_LABEL_STYLE = { fontSize: '13px' };

class TableEventsComponent extends Component {

    constructor() {
        super();
        this.state = {
            quantityShowRows: 25,
            currentPage: 1,
            totalItems: 0,
            statusFilter: '',
            // '' = todas · 'none' = sólo los eventos sueltos · '<id>' = una serie (FR-033).
            seriesFilter: '',
            // Las series con su próxima jornada, para el <select> y para la fila colapsada.
            // El dato de "próxima" sale de acá y NO de comparar fechas en el navegador (TC-002).
            series: [],
            // Qué series están desplegadas, por id.
            expanded: {},
            data: [],
            loaded: false,
        };
    }

    componentDidMount() {
        this.fetchData();
        this.loadSeries();
    }

    // El filtro por serie es un agregado de la grilla: si la llamada falla, la grilla sigue
    // andando sin él. Por eso no hay alert ni se toca `loaded`.
    loadSeries = () => {
        listSeries()
            .then((data) => this.setState({ series: (data && data.series) || [] }))
            .catch((error) => console.error('No se pudieron cargar las series:', error));
    }

    fetchData = ({
        page = this.state.currentPage,
        limit = this.state.quantityShowRows,
        status = this.state.statusFilter,
        series = this.state.seriesFilter,
        showLoader = true,
    } = {}) => {
        if (showLoader) {
            this.setState({ loaded: false });
        }
        const request = {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        };

        const query = buildPaginationQuery({
            page,
            limit,
            extraParams: {
                status: status || undefined,
                // FR-033: uno o el otro, nunca los dos. (El backend le da prioridad a
                // `withoutSeries` si llegaran juntos, pero mandar los dos sería decir dos cosas.)
                seriesId: series && series !== 'none' ? series : undefined,
                withoutSeries: series === 'none' ? 1 : undefined,
            },
        });
        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}manage-events?${query}`, request)
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                if (data.error == 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
            } else {
                // El backend devuelve { data: { events: [...] } } (no paginado, snake_case, con
                // `seriesId`/`seriesName` aplanados).
                const events = (data.data && data.data.events) || [];
                this.setState({
                    data: events,
                    currentPage: 1,
                    totalItems: events.length,
                    statusFilter: status,
                    seriesFilter: series,
                    loaded: true,
                });
            }
        })
        .catch((error) => {
            console.error('No se pudieron cargar los eventos:', error);
            this.setState({
                data: [],
                totalItems: 0,
                statusFilter: status,
                seriesFilter: series,
                loaded: true,
            });
        });
    }

    onChangeStatus = (e) => {
        this.fetchData({ page: 1, status: e.target.value });
    }

    // Filtrar por una serie la DESPLIEGA: elegirla y que la grilla siga mostrando una fila
    // colapsada sería un click de más para ver lo que se acaba de pedir.
    onChangeSeries = (e) => {
        const series = e.target.value;
        this.setState((prev) => ({
            expanded: series && series !== 'none' ? { ...prev.expanded, [series]: true } : prev.expanded,
        }));
        this.fetchData({ page: 1, series });
    }

    toggleSerie = (seriesId) => {
        this.setState((prev) => ({ expanded: { ...prev.expanded, [seriesId]: !prev.expanded[seriesId] } }));
    }

    branchLabel = (item) => {
        if (item.branchName) return item.branchName;
        if (item.branch && item.branch.name) return item.branch.name;
        return item.branch_id;
    }

    // Jornadas del club: la misma jornada todas las semanas. La copia nace en borrador una
    // semana después, con sus tipos de entrada, y se abre para ajustar fecha y publicar.
    duplicar = (item) => {
        if (!window.confirm(`¿Duplicar "${item.title}"? La copia queda en borrador, una semana después, con los mismos tipos de entrada.`)) return;
        duplicateEvent(item.id)
            .then((data) => navigateTo(`/editEvent?id=${data.event.id}`))
            .catch((e) => alert(e.message));
    }

    drawRow = (item, index, hija = false) => {
        // ENI-213: "Anotados" es cuánta gente VIENE. `sold` es la guarda de cupo e incluye las
        // pendientes (checkouts de MP abandonados), así que se muestran por separado.
        const att = item.attendees || { confirmed: 0, pending: 0 };
        return (
            <tr role="row" key={item.id} style={{ background: index % 2 == 0 ? '#ffffff' : '#fcfcfc' }}>
                <td style={hija ? { paddingLeft: 32 } : null}>
                    {hija && <span className="text-muted mr-1">↳</span>}
                    {item.title}
                    {/* Sólo mostrador (`counter_only`, un cumpleaños): también es privado, pero
                        no es una jornada del club ni se vende por link. Se nombra por lo que es. */}
                    {Number(item.counter_only) ? (
                        <span className="badge badge-secondary ml-2" title="No se abre ni se vende por la web">Sólo mostrador</span>
                    ) : item.visibility === 'private' && (
                        <span className="badge badge-secondary ml-2" title="No se lista en la web: jornada del club">Privado</span>
                    )}
                </td>
                <td>{formatEventDateTime(item.starts_at)}</td>
                <td>{formatEventDateTime(item.ends_at)}</td>
                <td>{item.capacity != null ? item.capacity : '-'}</td>
                <td>
                    {att.confirmed}
                    {att.pending > 0 && <small className="text-muted"> (+{att.pending} pend.)</small>}
                </td>
                <td>{EVENT_STATUS_LABEL[item.status] || item.status}</td>
                <td className="text-right text-nowrap">
                    <button type="button" className="btn btn-sm btn-white" onClick={() => navigateTo(`/editEvent?id=${item.id}`)}>
                        Editar
                    </button>
                    <button type="button" className="btn btn-sm btn-outline-secondary ml-2" onClick={() => navigateTo(`/eventAdmissions?id=${item.id}`)}>
                        Anotados
                    </button>
                    <button type="button" className="btn btn-sm btn-outline-secondary ml-2" title="Copia en borrador, una semana después" onClick={() => this.duplicar(item)}>
                        Duplicar
                    </button>
                    {/* La planilla del evento (sheet_url, ENI-215) se cargaba pero no había cómo
                        abrirla desde la grilla. Es un link EXTERNO (Google Sheets), así que va
                        con <a target="_blank"> y no con navigateTo, que es para rutas propias.
                        rel="noopener noreferrer": sin eso la pestaña nueva puede tocar
                        window.opener de la sesión del backoffice.
                        Sólo se muestra si el evento tiene planilla — un botón que no lleva a
                        ningún lado es peor que no tenerlo. */}
                    {item.sheet_url && (
                        <a
                            className="btn btn-sm btn-outline-secondary ml-2"
                            href={item.sheet_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            title={item.sheet_url}
                        >
                            Planilla
                        </a>
                    )}
                </td>
            </tr>
        );
    }

    /**
     * La fila colapsada de una serie (FR-033).
     *
     * "Próxima" la decide el BACKEND (`nextEvent` de `/manage-series`, que compara contra su
     * propia fecha de calendario): acá no se comparan fechas, que es lo que prohíbe TC-002. Si
     * la llamada a series falló, la fila igual se dibuja con el nombre aplanado que trae cada
     * evento (`seriesName`) y sin la línea de la próxima — la grilla no se rompe por eso.
     */
    drawSeriesRow = (seriesId, seriesName, grupo) => {
        const clave = String(seriesId);
        const abierta = !!this.state.expanded[clave];
        const serie = this.state.series.find((s) => String(s.id) === clave);
        const prox = serie ? serie.nextEvent : null;
        return (
            <tr role="row" key={`serie-${clave}`} style={{ background: '#f5f6f8', fontWeight: 600 }}>
                <td>
                    <button type="button" className="btn btn-sm btn-white mr-2" style={{ lineHeight: 1, padding: '0 7px' }}
                        title={abierta ? 'Plegar' : 'Desplegar'} onClick={() => this.toggleSerie(clave)}>
                        {abierta ? '−' : '+'}
                    </button>
                    {(serie && serie.name) || seriesName || `Serie ${clave}`}
                    <small className="text-muted ml-2" style={{ fontWeight: 400 }}>
                        {grupo.length} {grupo.length === 1 ? 'jornada' : 'jornadas'}
                    </small>
                </td>
                <td colSpan="2" style={{ fontWeight: 400 }}>
                    {prox ? (
                        <>
                            Próxima: {formatEventDateTime(prox.startsAt)} · {prox.sold}{prox.capacity != null ? `/${prox.capacity}` : ''}
                            {prox.full && <span className="badge badge-warning ml-2">Cupo completo</span>}
                        </>
                    ) : <span className="text-muted">Sin próxima jornada</span>}
                </td>
                <td colSpan="3"></td>
                <td className="text-right text-nowrap">
                    <button type="button" className="btn btn-sm btn-white" onClick={() => navigateTo(`/series/${clave}`)}>
                        Ir a la serie
                    </button>
                </td>
            </tr>
        );
    }

    /**
     * FR-033: cada serie se colapsa en UNA fila expandible y los eventos sueltos se listan como
     * siempre. El agrupado se hace sobre lo que ya está en `this.state.data` —el backend
     * devuelve el listado completo, sin paginar— y respeta su orden (`starts_at DESC`): la
     * serie aparece donde estaba su jornada más reciente.
     */
    loadData = () => {
        if (!this.state.loaded) {
            return <tbody></tbody>;
        }
        const items = [];
        const emitidas = new Set();
        this.state.data.forEach((item, index) => {
            if (item.seriesId == null) {
                items.push(this.drawRow(item, index));
                return;
            }
            const clave = String(item.seriesId);
            if (emitidas.has(clave)) return;   // ya salió con su grupo
            emitidas.add(clave);
            const grupo = this.state.data.filter((e) => String(e.seriesId) === clave);
            items.push(this.drawSeriesRow(clave, item.seriesName, grupo));
            if (this.state.expanded[clave]) {
                grupo.forEach((jornada, i) => items.push(this.drawRow(jornada, i, true)));
            }
        });
        if (items.length === 0) {
            items.push(
                <tr key="empty">
                    <td colSpan="7" style={{ textAlign: 'center', padding: '10px', border: '1px solid rgb(225, 229, 235)' }}>
                        No hay eventos para mostrar.
                    </td>
                </tr>
            );
        }
        return <tbody>{items}</tbody>;
    }

    renderLoader = () => {
        return (
            <div
                style={{
                    background: '#ffffff',
                    borderRadius: '0.625rem',
                    boxShadow: '0 .125rem .625rem rgba(90,97,105,.12)',
                    border: '1px solid #e1e5eb',
                    minHeight: '320px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2rem',
                }}
            >
                <div className="containerLoader" style={{ display: 'block', position: 'static', width: '100%' }}>
                    <div className="loader"></div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">
                <div className="dataTables_filter" style={{ marginBottom: '1rem' }}>
                    {/* El tema pone `.dataTables_filter label { font-size: 0 }` para ocultar el
                        "Search:" de las tablas viejas: sin el fontSize explícito, el nombre del
                        filtro no se ve y queda un combo suelto sin decir qué filtra. */}
                    <label style={FILTER_LABEL_STYLE}>Estado:&nbsp;
                        <select className="custom-select" style={{ width: 'auto', display: 'inline-block' }} value={this.state.statusFilter} onChange={this.onChangeStatus}>
                            <option value="">Todos</option>
                            <option value="draft">Borrador</option>
                            <option value="published">Publicado</option>
                            <option value="closed">Cerrado</option>
                            <option value="cancelled">Cancelado</option>
                        </select>
                    </label>
                    {/* FR-033: el filtro por serie. Sólo aparece si hay series cargadas — sin
                        club, la barra de la grilla queda exactamente como estaba. */}
                    {this.state.series.length > 0 && (
                        <label className="ml-3" style={FILTER_LABEL_STYLE}>Serie:&nbsp;
                            <select className="custom-select" style={{ width: 'auto', display: 'inline-block' }} value={this.state.seriesFilter} onChange={this.onChangeSeries}>
                                <option value="">Todas</option>
                                <option value="none">Sin serie (eventos sueltos)</option>
                                {this.state.series.map((s) => (
                                    <option key={s.id} value={s.id}>{s.name}</option>
                                ))}
                            </select>
                        </label>
                    )}
                </div>

                {!this.state.loaded ? this.renderLoader() : (
                    <table className="transaction-history d-none dataTable no-footer dtr-inline" id="DataTables_Table_0" role="grid">
                        <thead>
                            <tr role="row">
                                {/* ENI-213: fuera Sucursal (siempre la misma) y Tipos (un número
                                    sin acción). Entra Fin, que faltaba, y Anotados. */}
                                {/* Título cede 5% a la columna de acciones: con el botón de
                                    Planilla son tres y en 14% se partían en dos líneas. */}
                                <th rowSpan="1" colSpan="1" style={{ width: '23%' }}>Título</th>
                                <th rowSpan="1" colSpan="1" style={{ width: '14%' }}>Inicio</th>
                                <th rowSpan="1" colSpan="1" style={{ width: '14%' }}>Fin</th>
                                <th rowSpan="1" colSpan="1" style={{ width: '8%' }}>Cupo</th>
                                <th rowSpan="1" colSpan="1" style={{ width: '12%' }}>Anotados</th>
                                <th rowSpan="1" colSpan="1" style={{ width: '10%' }}>Estado</th>
                                <th rowSpan="1" colSpan="1" style={{ width: '19%' }}></th>
                            </tr>
                        </thead>
                        {this.loadData()}
                    </table>
                )}

                <PaginationComponent
                    totalItems={this.state.totalItems}
                    quantityRows={this.state.quantityShowRows}
                    currentPage={this.state.currentPage}
                    onPageChange={(page) => this.fetchData({ page })}
                />
            </div>
        );
    }
}

export default TableEventsComponent;
